import styled from 'styled-components';

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 80%;
  justify-content: space-evenly;
  text-align: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;
